
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.68 34.81c4.956 1.048 9.852.935 14.714 0 3.354-.642 5.621-3.931 6.159-8.595.608-5.317.584-10.849 0-16.571-.48-4.687-2.84-7.683-6.159-8.596-4.99-1.374-9.887-1.385-14.713 0C3.36 2.006 1.083 4.98.522 9.644c-.654 5.463-.736 10.972 0 16.57.608 4.653 2.816 7.898 6.159 8.596z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.871.158a26.245 26.245 0 00-10.19.879C3.36 1.994 1.083 4.968.522 9.632c-.654 5.464-.736 10.972 0 16.571.105.8.257 1.555.456 2.265 5.61-3.977 10.658-10.748 13.65-19.151 1.098-3.098 1.846-6.174 2.243-9.16z","fill":"#136FAD"}}),_c('path',{attrs:{"d":"M5.99 12.301a.642.642 0 01-.654-.63c0-.35.292-.631.654-.631 5.294-.36 10.635-.327 16.023 0 .362 0 .654.281.654.63 0 .35-.292.631-.654.631a245.112 245.112 0 00-16.023 0zM5.99 18.531a.642.642 0 01-.654-.63c0-.35.292-.631.654-.631 5.294-.36 10.635-.327 16.023 0 .362 0 .654.281.654.63 0 .35-.292.631-.654.631a245.112 245.112 0 00-16.023 0zM5.99 24.761a.642.642 0 01-.654-.63c0-.35.292-.631.654-.631 5.294-.36 10.635-.327 16.023 0 .362 0 .654.281.654.63 0 .35-.292.631-.654.631a245.042 245.042 0 00-16.023 0z","fill":"#fff"}})])
          )
        }
      }
    